var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"amber darken-2"},on:{"click":function($event){return _vm.upload()}},slot:"activator"},[_c('v-icon',[_vm._v("file_upload")])],1),_c('span',[_vm._v("Upload")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }